import { Component } from '@angular/core';
import * as $ from 'jquery';

import { ConfigApp } from './config';
import {UserLogIn} from "./components/core/UserManager";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent {
  pageTitle: string | undefined;

  config: any;

  infoUserLogin: UserLogIn;

  constructor() {
    this.config = ConfigApp;
    this.infoUserLogin = new UserLogIn(null);
  }

  ngOnInit(){
    let that = this;
    setTimeout(function(){
      that.startFunctionNotLoaded();
    },500);
  }

  startFunctionNotLoaded(){
    // @ts-ignore
    jQuery('*[data-toggle="tooltip"]').tooltip();

  }


  static showLoading() {
    $('html').addClass('overflow-hidden');
    $('#preload').show();
  }

  static hideLoading() {
    $('html').removeClass('overflow-hidden');
    $('#preload').hide();
  }

  public getClassColumns(col) {
    if (col) return 'col-' + col;
    return 'col-12';
  }

  static finishApply(node, message, success) {
    node.attr('style', '');
    node.addClass('d-inline').html(message);
    node.fadeOut(4000, function () {
      node.removeClass('d-inline').html('');
      $('#saveForm').show();
    });
  }

  static getMessageSuccess() {
    $('#loadingSave').removeClass('d-inline');
    return 'Data saved successfully!';
  }

  static getMessageError(error) {
    if (ConfigApp.debug) console.error('Error:' + JSON.stringify(error));
    return error.code + ' ' + error.message;
  }
}
